import { Component, OnInit } from "@angular/core";
import { TranslationService } from "app/services/translation.service";
import { Subscription } from "rxjs";

@Component({
  selector: "app-dashboard",
  templateUrl: "./dashboard.component.html",
  styleUrls: ["./dashboard.component.scss"],
})
export class DashboardComponent implements OnInit {
  public i18n;
  private subscriptions: Subscription[] = [];

  constructor(private translation_service: TranslationService) {}

  ngOnInit() {
    this.subscriptions.push(
      this.translation_service.current_dictionary_observable.subscribe(
        (data) => {
          this.i18n = data;
        }
      )
    );
    this.i18n = this.translation_service.getDictionary();
    console.log(this.i18n);
  }
}
